import {
  Component,
  Output,
  EventEmitter,
  Input,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'app-cta',
  templateUrl: './cta.component.html',
  styleUrls: ['./cta.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CtaComponent {
  /**
   * Emits a click event back to the parent component
   */
  @Output() clicked: EventEmitter<void> = new EventEmitter();

  /**
   * Set the kind of button (for styling)
   */
  @Input() kind: string;

  /**
   * Optional boolean to set small sized CTA
   */
  @Input() isSmall?: boolean;

  /**
   * Optional boolean to display checkbox
   */
  @Input() hasCheckbox?: boolean;

  /**
   * Optional boolean to set checkbox status
   */
  @Input() isChecked?: boolean;

  /**
   * Optional boolean to specify if the checkbox is disabled.
   */
  @Input() disabled?: boolean;

  /**
   * Boolean to specify if the CTA is of count variety - drives UI
   */
  @Input() hasCount?: boolean;

  /**
   * Required number value of items to compare
   */
  @Input() count?: number;

  /**
   * Boolean value to center the cta
   */
  @Input() centered?: boolean;

  /**
   * Conditionally fires emit(s) when cta is clicked
   */
  onClick(event) {
    event.stopPropagation();
    this.clicked.emit();
  }
}
